export interface IDriverDeviceOutputDto {
    lastReportDate?: string;
    appVersion?: string;
}
